import React from 'react';
import Countdown from 'react-countdown';

function CountdownSection() {
  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return <span>Event has started!</span>;
    } else {
      // Render a countdown
      return (
        <>
            <div class="time-countdown">                      
                <div class="counter-column">
                    <span class="count">{days}</span>
                    <sub>Days</sub>
                </div> 
                <div class="counter-column">
                    <span class="count">{hours}</span>
                    <sub>Hours</sub>
                </div> 
                <div class="counter-column">
                    <span class="count">{minutes}</span>
                    <sub>Minutes</sub>
                </div>
                <div class="counter-column">
                    <span class="count">{seconds}</span>
                    <sub>Seconds</sub>
                </div>
            </div>
    
        </>
      );
    }
  };

  return (
    <section className="countdown-section style-two">
        <div className="flower-3 bounce-y"></div>
        <div className="flower-4 bounce-y"></div>
        <div className="auto-container">
            <div className="inner-container">
            <div className="icon-flower-14"></div>
                <div className="outer-box">
                    <div className="content-box wow fadeInUp">
                    <div className="caption-box">
                        <div className="date">Dec 14, 2025</div>
                        <div className="address">
                        Lilou Hotel New York , 198 West <br />
                        27th Street, NY
                        </div>
                    </div>
                    </div>

                    <div className="time-counter wow fadeInLeft">
                    <Countdown 
                      date={new Date('12/14/2025')} 
                      renderer={renderer}
                    />
                    </div>
                    <div className="btn-box">
                    <a href="#contact" className="theme-btn btn-style-one"><span className="btn-title">Book your attendance</span></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}

export default CountdownSection;